import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Boutique',
    description: 'A camera-driven fashion lookbook for shopping complete designer outfits.',
    url: 'https://modulify.com'
}